import axios from "axios";
import React from "react";
import { SWRConfig } from "swr";
import siteConfig from "../variables";

type FetchProviderProps = {
  children?: React.ReactNode;
};

const { API_BASE, API_DEFAULT_TIMEOUT } = siteConfig;
axios.defaults.baseURL = API_BASE;
axios.defaults.timeout = parseInt(API_DEFAULT_TIMEOUT);
axios.defaults.validateStatus = (status) => status >= 200 && status < 500;

export const FetchProvider = ({ children }: FetchProviderProps) => {
  return (
    <SWRConfig
      value={{
        fetcher: (url) => axios.get(url),
        shouldRetryOnError: false,
        errorRetryInterval: 100,
        revalidateOnFocus: false,
      }}
    >
      {children}
    </SWRConfig>
  );
};
